import { Grid2, Typography } from '@mui/material';

const Title = ({ title, description, align = 'flex-start' }) => {
    return (
        <Grid2 container direction="column" justifyContent="flex-start" alignItems={align} gap="8px">
            <Typography variant="h4" component="h1" fontSize={20} fontWeight={900} sx={{ color: '#131313' }}>
                {title}
            </Typography>
            <Typography fontSize={16} fontWeight={500} sx={{ color: '#131313bf' }}>
                {description}
            </Typography>
        </Grid2>
    );
};

export default Title;
